import { IQuoteAnalyzed } from "./QuoteBionexo";
import { IDropdownOrderProducts } from "components/OrderDropdown/interface";
import { QuotationOrigin, SupplierStatusType } from "components/Table/interface";

export interface IQuotesData {
  data: Array<IQuotes>;
}

export enum QuoteStatusTypes {
  "WAITING_APPROVAL" = "Aguardando aprovação",
  "APPROVED" = "Aprovado",
}

interface Address {
  city: string;
  stateCode: string;
}

interface BuyerQuotation {
  name: string;
  identifier: string;
  identifierKind: string;
  billingAddress: Address;
}

export interface IQuotes {
  id: string;
  code: string;
  createdAt: Date;
  expiresAt: Date;
  category: string;
  itemsCount: number;
  categoryMafra: string;
  buyer: BuyerQuotation;
  quotationViewed: boolean;
  statusDescription: string;
  quotationDate: string;
  origin: string;
  quotationOrigin: string;
  itemsQuatity: number;
  price: number;
  imported: boolean;
  timeShipping: null;
  status: keyof typeof QuoteStatusTypes;
  supplierStatus: keyof typeof SupplierStatusType;
  order: null;
  sentBionexo: boolean;
  company: {
    crmCustomerCode: string;
    identifier: string;
    companyName: string;
    fantasyName: string;
    documentNumber: string;
    phone: string;
    comercialEmail: string;
    financialEmail: string;
    addresses: null;
  };
  items: Array<IDropdownOrderProducts>;
  quoteBU: string;
  subsidiary: string;
  subsidiaryElement: string;
  viewList?: ViewListQuoteProps[];
  quoteAnalyzed: Array<IQuoteAnalyzed>;
  isRead?: boolean;
  hasItemOl?: boolean;
  hasPreOrder: boolean;
  quoteWithAutomaticItems?: boolean;
  quotationNotParticipateStatusDescription?: string;
  hasPendingBudget?: boolean;
  supplierStatusDescription: string;
  userWhoSavedNotParticipateStatus?: string;
  supplierStatusMessage: string;
  notParticipateStatusDescription: string;
  priorityBCG?: DataBCGQuotation;
  indicators?: IndicatorsQuote;
  filterIndicators?: FilterIndicators;
}

export interface FilterIndicators {
  indicatorIsRead?: boolean;
  indicatorQuoteWithAutomaticItems?: boolean;
  indicatorOL?: boolean;
  indicatorPriorityItem?: boolean;
  indicatorCloseToExpiring?: boolean;
}

type DataBCGQuotation = {
  displayed: boolean;
  priorityEmoji: number;
  ranking: number;
  hasBCG: boolean;
}

export type QuotesReloadProps = {
  id: string;
  blockedQuote?: boolean;
};

export interface IndicatorsQuote {
  priorityItem: boolean;
  relevantItem: boolean;
  recurringItem: boolean;
  winningItem: boolean;
  closeToExpiring: boolean;
}

export interface ViewListQuoteProps {
  name: string;
  status: boolean;
  userName: string;
  updatedDate: string;
  history: BlockHistory[];
}
export interface BlockHistory {
  blockedIn: string;
}
export interface ResetCdsProps {
  quoteId: string;
  distributionCenter: string;
}

export interface ItemProps {
  QuoteId: string;
  brand: string;
  commercialCost: ItemStockProps;
  conversionAmount: number;
  conversionFactor?: number | string;
  crmCustomerCode: string;
  description: string;
  distributionCenter: string;
  factoryPrice: number;
  hasCommercialCost: boolean;
  id: string;
  itemBatch: ItemBatchProps[];
  itemStock: ItemStockProps[];
  medicineTypeDescription: string;
  multiple: number;
  notes?: string;
  packagingType: number;
  producer: string;
  productSegmentDescription: string;
  quantity: number;
  rentability: number;
  sequenceNumber: number;
  stock: string;
  subUnit: number;
  suggested: boolean;
  supplierProductcode: string;
  unit: string;
  unitPrice?: number | string;
  weight: string;
  message?: string;
  isBlockedItem?: boolean;
  blockedItemDescription?: string;
}

export interface ItemQuoteProps {
  unitPrice?: string;
  item?: ItemProps;
}

export interface ItemStockProps {
  blockMessage: string;
  blocked: boolean;
  commercialCost: number;
  factoryPrice: number;
  idealBilling: boolean;
  local: string;
  localDescription: string;
  minimumPrice: number;
  minimumProfitability: number;
  multiple: number;
  orderingPriority: string;
  priority: string;
  purchaseUnit: string;
  stock: number;
  stockLocked: number;
  subUnit: number;
  supplierProductCode: string;
  unitCode: string;
  agreementPrice?: number;
  isPricedAccordingly?: boolean;
  ol?: boolean;
  suggestedPrice?: number;
  idealBillingLocation?: string;
  minimumPriceLock1?: number;
  minimumPriceLock1Excpt?: number;
  minimumPriceLock2?: number;
  minimumPriceLock2Excpt?: number;
  pitagoras?: PitagorasProps[];
}

export interface PitagorasProps {
  distributionCenter: string;
  position: number;
  stock: number;
}

export interface BatchProps {
  balance: number;
  batchCode: string;
  validity: string;
}

export interface ItemBatchProps {
  batches: BatchProps[];
  distributionCenter: string;
  validityAlert: boolean;
}

export interface IMoneyBusinessUnit {
  identifier: string;
  name: string;
  segment: string;
}

export interface IMinimumBilling {
  quotationId: string;
  distributionCenters: string;
  distributionCenterSelected: string;
}
